// src/components/common/ProfileButton/ProfilePopover.js

import React, { useContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Popover from "../../UI-comp/Popover";
import PopupWithDropdown from "./PopupWithDropdown";
import "./PopupWithDropdown.css";
import ConfirmDeletePopup from "./ConfirmDeletePopup";

// ✅ "Show Profiles" has been REMOVED — it now lives in the Navbar Profiles dropdown.
// This popover only handles: Add Profile, Delete Profile, Archive Profile.

const ProfilePopover = ({ isOpen, referenceElement, onClose, nProfiles }) => {
  const navigate = useNavigate();

  const [isPopupOpen,            setIsPopupOpen]            = useState(false);
  const [profiles,               setProfiles]               = useState([]);
  const [selectedProfileId,      setSelectedProfileId]      = useState(null);
  const [confirmDeleteOpen,      setConfirmDeleteOpen]      = useState(false);
  const [deleteMessage,          setDeleteMessage]          = useState("");
  const [openDropdownIndex,      setOpenDropdownIndex]      = useState(null);
  const [selectedProfileToDelete,setSelectedProfileToDelete]= useState(null);
  const [archiveInstead,         setArchiveInstead]         = useState(false);

  const popoverRef = useRef(null);

  console.log("ProfilePopover — nProfiles:", nProfiles);

  // ── Close on outside click ────────────────────────────────────────────────
  useEffect(() => {
    if (!isOpen) return;
    const handleOutsideClick = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        referenceElement &&
        !referenceElement.contains(event.target)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen, referenceElement, onClose]);

  // ── Action handlers ───────────────────────────────────────────────────────

  const handleAddProfile = () => {
    navigate("/create-profile");
    onClose();
  };

  const handleDeleteProfile = () => {
    const storedProfiles = JSON.parse(localStorage.getItem("profiles") || "[]");
    if (storedProfiles.length === 0) {
      alert("No profile to delete.");
      return;
    }
    setProfiles(storedProfiles);
    setIsPopupOpen(true);
    onClose();
  };

  const handleArchiveProfile = () => {
    console.log("Archive profile triggered");
    // TODO: implement archive flow
    onClose();
  };

  // ── Option dispatcher ─────────────────────────────────────────────────────
  const handleOptionClick = (option) => {
    if (!option?.label) {
      console.error("Invalid option:", option);
      return;
    }

    const action = option.label.toLowerCase();

    if      (action === "add profile")     handleAddProfile();
    else if (action === "delete profile")  handleDeleteProfile();
    else if (action === "archive profile") handleArchiveProfile();
    else    console.error("Unknown profile action:", action);

    setOpenDropdownIndex(null);
  };

  // ── ✅ profileOptions — "Show Profiles" is REMOVED ───────────────────────
  const profileOptions = [
    {
      label   : "Add Space",
      action  : handleOptionClick,
      disabled: false,
    },
    {
      label   : "Delete Space",
      action  : handleOptionClick,
      disabled: nProfiles === 0,   // disabled when no profiles exist
    },
    {
      label   : "Archive Space",
      action  : handleOptionClick,
      disabled: nProfiles === 0,   // disabled when no profiles exist
    },
  ];

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      <Popover
        isOpen={isOpen}
        referenceElement={referenceElement}
        onClose={onClose}
        ref={popoverRef}
      >
        <ul className="ua-profile-action-container">
          {profileOptions.map((option, index) => (
            <li
              key={index}
              role="menuitem"
              tabIndex={option.disabled ? -1 : 0}
              onClick={() => !option.disabled && option.action(option)}
              onKeyUp={(e) => {
                if (!option.disabled && (e.key === "Enter" || e.key === " ")) {
                  option.action(option);
                }
              }}
              className={`ua-profile-action-btn ${option.disabled ? "ua-profile-action-btn-disabled" : ""}`}
              aria-disabled={option.disabled}
              style={{
                cursor : option.disabled ? "not-allowed" : "pointer",
                opacity: option.disabled ? 0.5 : 1,
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      </Popover>

      {/* ── Delete Profile — selection modal ─────────────────────────────── */}
      <PopupWithDropdown
        isOpen={isPopupOpen}
        onClose={() => {
          setIsPopupOpen(false);
          setSelectedProfileId(null);
        }}
        profiles={profiles}
        selectedProfileId={selectedProfileId}
        setSelectedProfileId={setSelectedProfileId}
        onNext={() => {
          setIsPopupOpen(false);
          setConfirmDeleteOpen(true);
        }}
      />

      {/* ── Success toast ─────────────────────────────────────────────────── */}
      {deleteMessage && (
        <div className="ua-success-toast">
          {deleteMessage}
          <button onClick={() => setDeleteMessage("")}>×</button>
        </div>
      )}
    </>
  );
};

export default ProfilePopover;
